import { defineSlotRecipe } from '@chakra-ui/react';

export const searchEngineMobileDrawerSlotRecipe = defineSlotRecipe({
    slots: ['label', 'drawerHeader', 'button'],
    base: {
        label: {
            fontSize: 'xs',
            color: 'gray.500',
        },
        drawerHeader: {
            fontSize: 'md',
            fontWeight: 'normal',
            borderBottomWidth: '1px',
        },
        button: {
            colorPalette: 'secondary',
        },
    },
});
